const reevaluationPeriod = {
  Years: 1,
  Months: 2,
};

export default reevaluationPeriod;
